<template>
  <div class="rightView">
    <section class="flexAro">
      <!--S 左侧菜单-->
      <Navgation @navSlide="navLeft"></Navgation>
      <!--S 左侧菜单-->
      <keep-alive :max="1">
        <router-view :class="['bigView childView',{'takeLeft':takeLeft}]" v-if="$route.meta.keepAliv"></router-view>
      </keep-alive>
      <router-view :class="['bigView childView',{'takeLeft':takeLeft},]" v-if="!$route.meta.keepAliv"></router-view>
      <!-- <router-view :class="['bigView childView',{'takeLeft':takeLeft},{'helpRight':helpRight}]" ></router-view> -->

      <!--S 帮助文档-->
      <!-- <helpCenter @helpCenter="closeHelp"></helpCenter> -->
      <!--E 帮助文档-->
    </section>
  </div>
</template>

<script>
  export default {
    name: "PageTranstion",
    data() {
      return {
        takeLeft: false,
        helpRight: true
      };
    },
    components: {
      Navgation: resolve =>
        require(["@/components/common/Navgation.vue"], resolve),
      helpCenter: resolve =>
        require(["@/components/common/helpCenter.vue"], resolve)
    },
    watch: {},
    methods: {
      //父组件接收传值
      navLeft(val) {
        this.takeLeft = val;
      },
      //关闭帮助文档
      closeHelp(val) {
        this.helpRight = val;
      }
    },
    mounted() { }
  };
</script>

<style scoped>
  .childView {
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }

  .helpRight .childView {
    right: 0 !important;
  }

  .rightView {
    position: absolute;
    transition: all 0.3s;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #f6f8fb;
    /* z-index:2; */
  }
</style>


// WEBPACK FOOTER //
// src/views/PageTransition.vue